import {memo, useEffect} from 'react';

import {useQuery} from '../hooks/use-query';
import {setToken} from '../utils/auth';
import {AUTH_REDIRECT_URL_QUERY} from '../utils/constants';

function Auth() {
  const query = useQuery();

  useEffect(() => {
    const token = query.get('token');
    const redirectUrl = query.get(AUTH_REDIRECT_URL_QUERY);
    if (token) {
      setToken(token);
      window.location.replace(redirectUrl || '/');
    }
  }, [query]);

  return null;
}

export const AuthPage = memo(Auth);
